var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBookmark({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 14,
    viewBox: "0 0 10 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.00195 1.2C1.00195 1.08954 1.0915 1 1.20195 1H8.80196C8.91241 1 9.00196 1.08954 9.00196 1.2V12.5C9.00196 12.6805 8.78164 12.7687 8.65713 12.6379L5.14678 8.95207C5.06796 8.86931 4.93594 8.86931 4.85713 8.95207L1.34678 12.6379C1.22227 12.7687 1.00195 12.6805 1.00195 12.5V1.2Z",
    fill: "#DB6443",
    stroke: "#DB6443"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmark);
export default __webpack_public_path__ + "static/media/bookmark.bb2c453a.svg";
export { ForwardRef as ReactComponent };